import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _wrap_native_super from "@swc/helpers/src/_wrap_native_super.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { fetchJSON, postJSON } from "@purple-dot/browser-sdk/src/libraries/fetch";
/* eslint-disable max-classes-per-file */ import { Errors, pollAsync } from "@purple-dot/libraries/src/language-helpers/promises/poll";
export var ERROR_MESSAGES = {
    CHECKOUT_SOLD_OUT: "We're sorry, this product sold out while we were processing your order. Any payment taken has been refunded",
    CHECKOUT_EXPIRED: "This checkout session has expired",
    CHECKOUT_UNEXPECTED_ERROR: "We're sorry, an unexpected error occured while processing your order. Any payment taken has been refunded. Please refresh the page to try again or contact customer support.",
    CHECKOUT_TIMEOUT: "Please check your email for your order confirmation. If it doesn't arrive in the next few minutes, please contact customer support to check the status of your order.",
    PAYMENT_METHOD_MISMATCH: "Please use the same card details as the original preorder",
    TOO_MANY_PAYING: "Oops! A few too many people are trying to checkout. Please try again in 1 minute.",
    SHIPPING_GROUPS_TIMEOUT: "We encountered a problem whilst calculating your shipping rate. Please try again.",
    UNKNOWN_ERROR: "We're sorry, it looks like something has gone wrong with your request, please try again"
};
export var CheckoutStateError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CheckoutStateError, Error1);
    var _super = _create_super(CheckoutStateError);
    function CheckoutStateError(message) {
        _class_call_check(this, CheckoutStateError);
        var _this;
        _this = _super.call(this, message);
        _this.data = {
            isUserRetryable: false
        };
        _this.originalMessage = message;
        _this.responseSucceeded = true;
        return _this;
    }
    return CheckoutStateError;
}(_wrap_native_super(Error));
export var CustomTimeoutError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CustomTimeoutError, Error1);
    var _super = _create_super(CustomTimeoutError);
    function CustomTimeoutError(message) {
        _class_call_check(this, CustomTimeoutError);
        var _this;
        _this = _super.call(this, message !== null && message !== void 0 ? message : ERROR_MESSAGES.CHECKOUT_TIMEOUT);
        _this.data = {
            isUserRetryable: false
        };
        _this.originalMessage = ERROR_MESSAGES.CHECKOUT_TIMEOUT;
        return _this;
    }
    return CustomTimeoutError;
}(_wrap_native_super(Error));
export function createCheckout(_) {
    return _createCheckout.apply(this, arguments);
}
function _createCheckout() {
    _createCheckout = _async_to_generator(function(param) {
        var _param, ref, storeId, skuId, presaleId, releaseId, lineItemProperties, userSessionToken, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], storeId = ref.storeId, skuId = ref.skuId, presaleId = ref.presaleId, releaseId = ref.releaseId, lineItemProperties = ref.lineItemProperties, userSessionToken = ref.userSessionToken;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/create", (_tmp.storeId = storeId, _tmp.skuId = skuId, _tmp.presaleId = presaleId, _tmp.releaseId = releaseId, _tmp.lineItemProperties = lineItemProperties, _tmp.userSessionToken = userSessionToken, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _createCheckout.apply(this, arguments);
}
export function updateInformation(_) {
    return _updateInformation.apply(this, arguments);
}
function _updateInformation() {
    _updateInformation = _async_to_generator(function(param) {
        var _param, ref, checkoutId, email, consentedToEmailMarketing, consentedToSmsMarketing, shippingAddress, isPrefill, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, email = ref.email, consentedToEmailMarketing = ref.consentedToEmailMarketing, consentedToSmsMarketing = ref.consentedToSmsMarketing, shippingAddress = ref.shippingAddress, isPrefill = ref.isPrefill;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId), (_tmp.email = email, _tmp.consentedToEmailMarketing = consentedToEmailMarketing, _tmp.consentedToSmsMarketing = consentedToSmsMarketing, _tmp.shippingAddress = shippingAddress, _tmp.isPrefill = isPrefill, _tmp.clientTimestamp = Date.now(), _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _updateInformation.apply(this, arguments);
}
export function confirmShippingOptions(_) {
    return _confirmShippingOptions.apply(this, arguments);
}
function _confirmShippingOptions() {
    _confirmShippingOptions = _async_to_generator(function(param) {
        var _param, ref, checkoutId, selectedRates, preorderShippingOptionId, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, selectedRates = ref.selectedRates, preorderShippingOptionId = ref.preorderShippingOptionId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/confirm-shipping-options", (_tmp.checkoutId = checkoutId, _tmp.selectedRates = selectedRates, _tmp.preorderShippingOptionId = preorderShippingOptionId, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _confirmShippingOptions.apply(this, arguments);
}
export function preferOriginalShipDate(_) {
    return _preferOriginalShipDate.apply(this, arguments);
}
function _preferOriginalShipDate() {
    _preferOriginalShipDate = _async_to_generator(function(param) {
        var _param, ref, checkoutId, preferOriginalShipDate, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, preferOriginalShipDate = ref.preferOriginalShipDate;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/prefer-original-ship-date", (_tmp.checkoutId = checkoutId, _tmp.preferOriginalShipDate = preferOriginalShipDate, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _preferOriginalShipDate.apply(this, arguments);
}
export function setCheckoutPaying(_) {
    return _setCheckoutPaying.apply(this, arguments);
}
function _setCheckoutPaying() {
    _setCheckoutPaying = _async_to_generator(function(param) {
        var _param, ref, checkoutId, paymentMethodType, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, paymentMethodType = ref.paymentMethodType;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/set-paying", (_tmp.checkoutId = checkoutId, _tmp.paymentMethodType = paymentMethodType, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    if (err.statusCode === 503 || err.statusCode === 429) {
                        err.originalMessage = ERROR_MESSAGES.TOO_MANY_PAYING;
                        throw err;
                    }
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _setCheckoutPaying.apply(this, arguments);
}
export function setCheckoutOpen(_) {
    return _setCheckoutOpen.apply(this, arguments);
}
function _setCheckoutOpen() {
    _setCheckoutOpen = _async_to_generator(function(param) {
        var _param, checkoutId, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/set-open", (_tmp.checkoutId = checkoutId, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _setCheckoutOpen.apply(this, arguments);
}
export function stopPaying(_) {
    return _stopPaying.apply(this, arguments);
}
function _stopPaying() {
    _stopPaying = _async_to_generator(function(param) {
        var _param, checkoutId, result, _tmp, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/stop-paying", (_tmp.checkoutId = checkoutId, _tmp))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _stopPaying.apply(this, arguments);
}
export function fetchCheckout(_) {
    return _fetchCheckout.apply(this, arguments);
}
function _fetchCheckout() {
    _fetchCheckout = _async_to_generator(function(param) {
        var _param, checkoutId, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        fetchJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _fetchCheckout.apply(this, arguments);
}
function fetchCheckoutState(_) {
    return _fetchCheckoutState.apply(this, arguments);
}
function _fetchCheckoutState() {
    _fetchCheckoutState = _async_to_generator(function(param) {
        var checkoutId, addToPreorderCheckout, checkout, _tmp, preorderCompleted, inStockCompleted, paymentCompleted, state, _tmp1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, addToPreorderCheckout = param.addToPreorderCheckout;
                    _tmp = {};
                    return [
                        4,
                        fetchCheckout([
                            (_tmp.checkoutId = checkoutId, _tmp)
                        ])
                    ];
                case 1:
                    checkout = _state.sent();
                    preorderCompleted = !!checkout.preorder;
                    inStockCompleted = !checkout.hasRegularLineItems || !!checkout.order;
                    paymentCompleted = checkout.paymentCompleted;
                    state = checkout.state;
                    // Don't consider the checkout complete until both orders have been completed
                    if ((state === "PAYING" || state === "COMPLETED") && paymentCompleted && !inStockCompleted && !addToPreorderCheckout) {
                        state = "RECEIVED";
                    }
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.state = state, _tmp1.error = checkout.error, _tmp1.preorderCompleted = preorderCompleted, _tmp1.inStockCompleted = inStockCompleted, _tmp1.paymentCompleted = paymentCompleted, _tmp1)
                    ];
            }
        });
    });
    return _fetchCheckoutState.apply(this, arguments);
}
var SIX_MINUTES = 360000;
var TWENTY_SECONDS = 20000;
export function waitForCheckoutCompleted(_) {
    return _waitForCheckoutCompleted.apply(this, arguments);
}
function _waitForCheckoutCompleted() {
    _waitForCheckoutCompleted = _async_to_generator(function(param) {
        var checkoutId, _completedTimeout, completedTimeout, _receivedTimeout, receivedTimeout, _addToPreorderCheckout, addToPreorderCheckout, result, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, _completedTimeout = param.completedTimeout, completedTimeout = _completedTimeout === void 0 ? SIX_MINUTES : _completedTimeout, _receivedTimeout = param.receivedTimeout, receivedTimeout = _receivedTimeout === void 0 ? TWENTY_SECONDS : _receivedTimeout, _addToPreorderCheckout = param.addToPreorderCheckout, addToPreorderCheckout = _addToPreorderCheckout === void 0 ? false : _addToPreorderCheckout;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        pollAsync(function() {
                            var _ref = _async_to_generator(function(timeSpent) {
                                var _ref, state, error, completed, _tmp, data, _tmp1, _tmp2, _tmp3, data1, _tmp4, _tmp5, err, _tmp6;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                6,
                                                ,
                                                7
                                            ]);
                                            _tmp = {};
                                            return [
                                                4,
                                                fetchCheckoutState((_tmp.checkoutId = checkoutId, _tmp.addToPreorderCheckout = addToPreorderCheckout, _tmp))
                                            ];
                                        case 1:
                                            _ref = _state.sent(), state = _ref.state, error = _ref.error, completed = _object_without_properties(_ref, [
                                                "state",
                                                "error"
                                            ]);
                                            if (!(state === "RECEIVED" && receivedTimeout >= 0 && timeSpent > receivedTimeout)) return [
                                                3,
                                                3
                                            ];
                                            _tmp1 = {};
                                            return [
                                                4,
                                                fetchCheckout([
                                                    (_tmp1.checkoutId = checkoutId, _tmp1)
                                                ])
                                            ];
                                        case 2:
                                            data = _state.sent();
                                            _tmp2 = {};
                                            return [
                                                2,
                                                (_tmp2.stopPolling = true, _tmp2.result = _object_spread(_object_spread_props(_object_spread({}, data), {
                                                    state: state
                                                }), completed), _tmp2)
                                            ];
                                        case 3:
                                            if (error === "PAYMENT_METHOD_MISMATCH") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.PAYMENT_METHOD_MISMATCH);
                                            }
                                            _tmp3 = {};
                                            if (state === "PAYING" || state === "RECEIVED") {
                                                return [
                                                    2,
                                                    (_tmp3.stopPolling = false, _tmp3)
                                                ];
                                            }
                                            if (!(state === "COMPLETED" || state === "OPEN")) return [
                                                3,
                                                5
                                            ];
                                            _tmp4 = {};
                                            return [
                                                4,
                                                fetchCheckout([
                                                    (_tmp4.checkoutId = checkoutId, _tmp4)
                                                ])
                                            ];
                                        case 4:
                                            data1 = _state.sent();
                                            _tmp5 = {};
                                            return [
                                                2,
                                                (_tmp5.stopPolling = true, _tmp5.result = _object_spread({}, data1, completed), _tmp5)
                                            ];
                                        case 5:
                                            if (state === "SOLD_OUT") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_SOLD_OUT);
                                            }
                                            if (state === "EXPIRED") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_EXPIRED);
                                            }
                                            // state === ERROR
                                            throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_UNEXPECTED_ERROR);
                                        case 6:
                                            err = _state.sent();
                                            _tmp6 = {};
                                            // Keep polling if there's a network error
                                            if (!err.responseSucceeded) {
                                                return [
                                                    2,
                                                    (_tmp6.stopPolling = false, _tmp6.result = false, _tmp6)
                                                ];
                                            }
                                            throw withDefaultedUnknownMessage(err);
                                        case 7:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(timeSpent) {
                                return _ref.apply(this, arguments);
                            };
                        }(), function(polledTimes) {
                            // After ~2 minutes
                            if (polledTimes > 30) {
                                return 10000;
                            }
                            // After ~45 seconds
                            if (polledTimes > 15) {
                                return 5000;
                            }
                            // After ~20 seconds
                            if (polledTimes > 10) {
                                return 3000;
                            }
                            // After ~4 seconds
                            if (polledTimes > 5) {
                                return 1500;
                            }
                            return 750;
                        }, completedTimeout)
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    err = _state.sent();
                    if (_instanceof(err, Errors.PollingTimeoutError)) {
                        throw new CustomTimeoutError();
                    }
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _waitForCheckoutCompleted.apply(this, arguments);
}
export function addItemToCheckout(_) {
    return _addItemToCheckout.apply(this, arguments);
}
function _addItemToCheckout() {
    _addItemToCheckout = _async_to_generator(function(param) {
        var _param, ref, checkoutId, skuId, presaleId, releaseId, result, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, skuId = ref.skuId, presaleId = ref.presaleId, releaseId = ref.releaseId;
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/add", (_tmp.checkoutId = checkoutId, _tmp.skuId = skuId, _tmp.presaleId = presaleId, _tmp.releaseId = releaseId, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _addItemToCheckout.apply(this, arguments);
}
export function removeItemFromCheckout(_) {
    return _removeItemFromCheckout.apply(this, arguments);
}
function _removeItemFromCheckout() {
    _removeItemFromCheckout = _async_to_generator(function(param) {
        var _param, ref, checkoutId, lineItemId, result, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, lineItemId = ref.lineItemId;
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/remove", (_tmp.checkoutId = checkoutId, _tmp.lineItemId = lineItemId, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _removeItemFromCheckout.apply(this, arguments);
}
export function addDiscountCodeToCheckout(_) {
    return _addDiscountCodeToCheckout.apply(this, arguments);
}
function _addDiscountCodeToCheckout() {
    _addDiscountCodeToCheckout = _async_to_generator(function(param) {
        var _param, ref, checkoutId, code, result, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, code = ref.code;
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/add-discount-code", (_tmp.checkoutId = checkoutId, _tmp.code = code, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _addDiscountCodeToCheckout.apply(this, arguments);
}
export function getAddToPreorderView(_) {
    return _getAddToPreorderView.apply(this, arguments);
}
function _getAddToPreorderView() {
    _getAddToPreorderView = _async_to_generator(function(param) {
        var _param, checkoutId, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        fetchJSON("/embedded-checkout/add-to-preorder/view?checkoutId=".concat(checkoutId))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getAddToPreorderView.apply(this, arguments);
}
export function removeDiscountCodeFromCheckout(_) {
    return _removeDiscountCodeFromCheckout.apply(this, arguments);
}
function _removeDiscountCodeFromCheckout() {
    _removeDiscountCodeFromCheckout = _async_to_generator(function(param) {
        var _param, ref, checkoutId, discountApplicationId, result, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, discountApplicationId = ref.discountApplicationId;
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/remove-discount-code", (_tmp.checkoutId = checkoutId, _tmp.discountApplicationId = discountApplicationId, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _removeDiscountCodeFromCheckout.apply(this, arguments);
}
export function fetchAvailableShippingRates(_) {
    return _fetchAvailableShippingRates.apply(this, arguments);
}
function _fetchAvailableShippingRates() {
    _fetchAvailableShippingRates = _async_to_generator(function(param) {
        var _param, checkoutId, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        fetchJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-rates"))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _fetchAvailableShippingRates.apply(this, arguments);
}
export function fetchShippingOptions(_) {
    return _fetchShippingOptions.apply(this, arguments);
}
function _fetchShippingOptions() {
    _fetchShippingOptions = _async_to_generator(function(param) {
        var _param, checkoutId, result, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-group-options"))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    if (err.statusCode === 503 || err.statusCode === 429) {
                        throw new CheckoutStateError(ERROR_MESSAGES.SHIPPING_GROUPS_TIMEOUT);
                    }
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchShippingOptions.apply(this, arguments);
}
export function setShippingGroupOptions(_) {
    return _setShippingGroupOptions.apply(this, arguments);
}
function _setShippingGroupOptions() {
    _setShippingGroupOptions = _async_to_generator(function(param) {
        var checkoutId, option, selectedShippingGroupRates, confirm, preferOriginalShipDate, result, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, option = param.option, selectedShippingGroupRates = param.selectedShippingGroupRates, confirm = param.confirm, preferOriginalShipDate = param.preferOriginalShipDate;
                    _tmp = {};
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-group-options"), (_tmp.option = option, _tmp.confirm = confirm, _tmp.selectedShippingRates = selectedShippingGroupRates && Object.entries(selectedShippingGroupRates).map(function(param) {
                            var _param = _sliced_to_array(param, 2), shippingGroupId = _param[0], rateId = _param[1];
                            return {
                                shippingGroupId: shippingGroupId,
                                rateId: rateId
                            };
                        }), _tmp.clientTimestampMs = Date.now(), _tmp.preferOriginalShipDate = preferOriginalShipDate, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _setShippingGroupOptions.apply(this, arguments);
}
function withDefaultedUnknownMessage(err) {
    // eslint-disable-next-line no-param-reassign
    err.originalMessage = err.originalMessage || ERROR_MESSAGES.UNKNOWN_ERROR;
    return err;
}
